import {Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IWorkspaceInstance } from './workspaces.reducer';
import { Config } from '../universal-config';

@Component({
  selector: 'nns-workspace-select-item',
  template: `
    <div class="nns-select-item">
      <div *ngIf="!avatarUrl" class="nns-select-item--logo m-no-avatar" [ngStyle]="{'background-color': '#' + workspace.color}">
        <span>{{ workspace.title[0] }}</span>
      </div>
      <div *ngIf="avatarUrl" class="nns-select-item--logo">
        <img [src]="avatarUrl + '?height=64'" height="32">
      </div>
      <div class="nns-select-item--text">
        <div class="nns-select-item--title" [title]="workspace.title">{{workspace.title}}</div>
        <div class="nns-select-item--subtitle" [title]="subtitle">
          {{subtitle}}
        </div>
      </div>
      <span class="nns-header-profile-arrow nns-animated active" *ngIf="hasArrow"></span>
    </div>
  `,
  styles: [`
    .nns-select-item{
      display: flex;
      padding: 8px;
      border-radius: 4px;
      transition: 0.3s;
      transition-property: background-color;
      align-items: center;
      cursor: pointer;
      position: relative;
    }

    .nns-select-item:hover, .nns-select-item.active{
      background-color: rgba(0, 0, 0, 0.08);
    }

    .nns-select-item--logo{
      width: 32px;
      height: 32px;
      flex: 0 0 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 12px;
      border-radius: 50%;
      color: #fff;
      text-transform: uppercase;
      font-weight: bold;
      overflow: hidden;
    }

    .nns-select-item--logo.m-no-avatar{
      background-color: #8BC34A;
    }

    .nns-select-item--text{
      width: calc(100% - 56px);
    }

    .nns-select-item--subtitle{
      font-size: 12px;
      opacity: 0.6;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .nns-select-item--title{
      font-weight: bold;
      font-size: 13px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      max-width: 100%;
    }

    .nns-select-item-desc{
      font-size: 12px;
      line-height: 16px;
      color: rgba(0, 0, 0, 0.6);
    }

    .nns-header-profile-arrow {
      display:block;
      content:"";
      height:0;
      border:none;
      border:4px solid transparent;
      border-top:4px solid rgba(0, 0, 0, 0.6);
      margin:6px 0 0 8px;
      margin-left: auto;
    }
  `,
  `
    :host.active .nns-select-item{
      background-color: rgba(0, 0, 0, 0.08);
    }

    :host.nns-select-item__disabled .nns-select-item:hover {
      cursor: default;
      background-color: transparent;
    }

    :host-context(.nns-theme-night) .nns-header-profile-arrow {
      border-top-color: #fff;
    }
  `]
})

export class WorkspaceSelectItemComponent implements OnChanges{
  @Input() workspace: IWorkspaceInstance;
  @Input() isOwner: boolean;
  @Input() hasArrow: boolean;

  isShowDropdown: boolean;

  owner;
  countMembers;
  avatarUrl = '';
  subtitle: string;
  isPersonal: boolean;

  constructor(private config: Config) {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.workspace && changes.workspace.currentValue) {
      const ws = changes.workspace.currentValue;
      this.owner = ws.owner;
      this.avatarUrl = this.getStaticFileUrl(ws.avatar.storedFileUUID)
      if (ws.countMembers && ws.countMembers.count && ws.countMembers.count >= 1) {
        this.countMembers = ws.countMembers.count;
      } else {
        this.countMembers = 0;
      }
      this.isPersonal = ws.orgId.startsWith('u');
    }

    if(changes.isOwner || changes.workspace || this.isPersonal && this.workspace) {
      this.setSubtitle();
    }
  }

  setSubtitle() {
    if(this.isOwner) {
      if(this.countMembers) {
        this.subtitle = `${this.countMembers} members`;
      } else {
        this.subtitle = this.isPersonal ? 'Personal workspace' : 'Business workspace';
      }
    } else {
      if(this.owner.firstname || this.owner.lastname) {
        this.subtitle = `${this.owner.firstname} ${this.owner.lastname}`;
      } else {
        this.subtitle = this.owner.email;
      }
    }
  }

  getStaticFileUrl(uuid) {
    return uuid ? `${ this.config.get('BOX_URL') }/file/${ uuid }` : ''
  }

}
